import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { ModalPanel, ModalSidebarContext } from '../../../../../../components/ModalSidebar'
import SubmissionError from './SubmissionError'

const propTypes = {
  /**
   * Indicates if submission was successful or not
   */
  hasSubmissionError: PropTypes.bool,
  /**
   * Content to render if submission was successful
   */
  successContent: PropTypes.node.isRequired,
  /**
   * Content to render if submission had errors
   */
  errorContent: PropTypes.node.isRequired,
  /**
   * key of the step of the modal it should return if showing the back button
   */
  backStepKey: PropTypes.string.isRequired,
}

/**
 * Panel to show after submiting the request
 * It checks Formik validation errors and uses the ModalSidebarContext
 */
function SubmitResultPanel(props) {
  const { hasSubmissionError = false, successContent, errorContent, backStepKey } = props ?? {}

  const { goToStep } = useContext(ModalSidebarContext)
  const { errors: validationErrors } = useFormikContext()

  const hasErrors = !isEmpty(validationErrors) || hasSubmissionError
  const leftButton = hasErrors
    ? {
        label: 'GENERAL.BACK',
        variant: 'primary',
        onClick: () => goToStep(backStepKey),
      }
    : null

  return (
    <ModalPanel leftButton={leftButton} rightButton="close">
      <SubmitPanelContent
        hasSubmissionError={hasSubmissionError}
        validationErrors={validationErrors}
        successContent={successContent}
        errorContent={errorContent}
      />
    </ModalPanel>
  )
}

/* eslint-disable react/prop-types */
function SubmitPanelContent(props) {
  const { hasSubmissionError, validationErrors, successContent, errorContent } = props

  // formik runs the validation every time on submit
  // in this step the form should be already validated and good to go
  // however if anything happens show all errors here
  if (!isEmpty(validationErrors)) {
    return (
      <SubmissionError
        message={<FormattedMessage id="GENERAL.MODAL_VALIDATION_FAILED" />}
        errors={Object.entries(validationErrors).map(([key, value]) => `${key}: ${value}`)}
      />
    )
  }

  if (hasSubmissionError) {
    return errorContent
  }

  // success case
  return successContent
}

SubmitResultPanel.propTypes = propTypes

export default SubmitResultPanel
